module.exports = __webpack_public_path__ + "static/media/myProfileIconInactive.6c7c3d9e.svg";